// extracted by mini-css-extract-plugin
module.exports = {"biblio":"Biblio_biblio__1MqSU","biblio__list-item":"Biblio_biblio__list-item__qIWv-","biblio__list-item-body":"Biblio_biblio__list-item-body__33WhD"};